export default {
  path: '/trackers/tracker-models',
  name: 'TrackerModels',
  component: () => import(/* webpackChunkName: "base" */ '../views/TrackerModelsView.vue'),
  meta: {
    exclude: false,
    requiresAuth: true
  }
}
